module.exports = __webpack_public_path__ + "img/image51.c6e18b2b.png";